package top.wcpe.allincore.layout.engine

import top.wcpe.allincore.layout.engine.internal.taffy.WasmTaffyLayoutEngine

/** JS 平台默认布局引擎：官方 Rust taffy 经 wasm 实现（ADR-0069），无状态即用即建。 */
actual fun defaultLayoutEngine(): LayoutEngine = WasmTaffyLayoutEngine()
